import { render, staticRenderFns } from "./ServiceTitle.vue?vue&type=template&id=015fbbee&"
import script from "./ServiceTitle.vue?vue&type=script&lang=js&"
export * from "./ServiceTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports